"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[8115],{

/***/ 83572:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"id":"grafana-azure-monitor-datasource"}');

/***/ })

}]);